"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const ModalMenu_1 = __importDefault(require("../../../components/modal/ModalMenu"));
const ModalSuccess_1 = __importDefault(require("../../../components/modal/ModalSuccess"));
const skeletons_1 = require("../../../components/skeletons");
const Home_1 = __importDefault(require("../../../networking/apis/Home"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const ItemArticles_1 = __importDefault(require("../../HomeScreen/components/ItemArticles"));
const styles_1 = __importDefault(require("./styles"));
const NewArticleScreen = () => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [visibleToast, setVisibleToast] = (0, react_1.useState)(false);
    const [contentToast, setContentToast] = (0, react_1.useState)("");
    const [page, setPage] = (0, react_1.useState)(1);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [listData, setListData] = (0, react_1.useState)([]);
    const displayTweet = (data) => {
        let list = [...listData];
        list = list.filter((item) => item?.article_id != data);
        setListData(list);
    };
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);
    (0, react_1.useEffect)(() => {
        if (connected) {
            setContentToast("");
            callApiNewArticles(1);
        }
    }, [connected]);
    (0, react_1.useEffect)(() => {
        let data = [];
        if (reloadPage == false) {
            if (dataCallApi) {
                data = listData.concat(dataCallApi);
                setListData(data);
            }
        }
        else {
            if (dataCallApi) {
                data = dataCallApi;
                setListData(data);
                setReloadPage(false);
            }
        }
    }, [dataCallApi]);
    const callApiNewArticles = async (data) => {
        try {
            let timeOneNewArticles = listData[0]?.posting_datetime || 0;
            let time = data == 1 ? false : (0, moment_1.default)(timeOneNewArticles).format('YYYY-MM-DD HH:mm:ss');
            const res = await Home_1.default.NewArticles(1, data, time);
            setDataCallApi(res.data.data);
        }
        catch (error) {
            setReloadPage(false);
        }
        finally {
        }
    };
    const reloadScreen = () => {
        setReloadPage(true);
        callApiNewArticles(1);
        setPage(1);
    };
    const handleLoadMore = () => {
        if (dataCallApi) {
            if (dataCallApi?.length < 5) {
                return false;
            }
            else {
                setPage(page + 1);
                callApiNewArticles(page + 1);
            }
        }
        return false;
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        loading ? (react_1.default.createElement(skeletons_1.ArticleSkeleton, null)) : (react_1.default.createElement(react_native_1.FlatList, { contentContainerStyle: {
                marginTop: (0, scale_1.scale)(5),
                paddingBottom: (0, scale_1.scale)(50),
            }, showsVerticalScrollIndicator: false, data: listData, renderItem: (item) => (react_1.default.createElement(react_native_1.View, { style: {
                    borderBottomColor: '#DDDDDD',
                    borderBottomWidth: 1,
                    width: '100%',
                    paddingLeft: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(ItemArticles_1.default, { data: item.item, showCreatedAt: true, displayTweet: (data) => {
                        displayTweet(data);
                    }, displayBlock: true }))), refreshing: reloadPage, onRefresh: reloadScreen, onEndReachedThreshold: 0.1, onEndReached: handleLoadMore })),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) }),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleToast, onClose: () => setVisibleToast(false), content: contentToast })));
};
exports.default = NewArticleScreen;
